'use strict';

angular.module('casist.core')
  .controller('FirmyCtrl', ['$scope', 'Restangular', 'Firma', 'Profile', '$controller', '$q', 'TabService', 'Outputs', '$modal', 'Notification', function ($scope, Restangular, Firma, Profile, $controller, $q, TabService, Outputs, $modal, Notification) {
    $scope.slideAnimation = true;

    $scope.SearchCtrl = $controller('SearchCtrl');

    $scope.firmy = [];
    var filterChanged = function(filter) {
      var promise = Firma.objects().getList(filter);
      $scope.firmy.loading = true;
      promise.then(function(data) {
        TabService.registerScope('firma', $scope);
        $scope.firmy = data;
      });
      return promise;
    };
    $scope.firmyTable = [
      { width: 40 },
      { selectAllAddon: true },
      { field: 'firma', label: 'firmy.FIRMA', filterCollapse: 'right' },
      { field: 'tel', label: 'firmy.TELEFON', filterType: 'icontains' },
      { field: 'email', label: 'firmy.EMAIL', filterType: 'icontains' },
      { field: 'ulica', label: 'firmy.ULICA'},
      { field: 'mesto', label: 'firmy.MESTO'},
      { field: 'splatnost', label: 'firmy.SPLATNOST', type: 'int', width: 70},
      { field: 'zlava', label: 'firmy.ZLAVA', type: 'number', width: 90},
      { field: 'ico', label: 'agendy.ICO'},
      { field: 'icdph', label: 'agendy.ICDPH'},
      { field: 'cennik__nazov', label: 'firmy.CENNIK'},
      { field: 'is_active', label: 'firmy.ACTIVE'}
    ];
    $scope.SearchCtrl.init({
      onChange: filterChanged,
      columnsDef: $scope.firmyTable,
      sort: {sort: 'firma'}
    });
    if (!$scope.helperController) {
      $scope.SearchCtrl.refresh(TabService.bus.get('firma'));

      var events = Firma.registerEvents(function() { return $scope.firmy; }, function() { return $scope.SearchCtrl; });
      $scope.$on('$destroy', function() {
        Firma.unregisterEvents(events);
        for (var i in unregisterProfileObservers) {
          unregisterProfileObservers[i]();
        }
      });
    }

    var unregisterProfileObservers = [];

    unregisterProfileObservers.push(Profile.addObserver('agenda', function() {
      $scope.SearchCtrl.cancelFilter(false);
      $scope.SearchCtrl.setLastPage();
      $scope.SearchCtrl.refresh();
    }));

    $scope.create = function(item) {
      return Firma.edit(item, $scope.firmy, $scope.SearchCtrl);
    };
    $scope.copy = function(item) {
      var copied = Firma.copy(item);
      _.each(['id'], function(field) {
        delete copied[field];
      });
      $scope.create(copied);
    };

    $scope.exportFirmy = function() {
      Outputs.openXLSExportUrl('firmy', $scope.SearchCtrl.getQuery());
    };
    $scope.openImport = function() {
      var modalInstance = $modal.open({
        templateUrl: 'core/import/import.html',
        controller: 'GenericImportCtrl',
        backdrop: 'static',
        windowClass: 'detail',
        resolve: {
          list: function() {
            return $scope.firmy;
          },
          model: function() {
            return Firma;
          }
        }
      });
      modalInstance.result.then(function(data) {
        Notification.add('Záznamy boli aktualizované.', 'success', 5);
        $scope.SearchCtrl.refresh();
      });
    };

    $scope.selectedItems = {};
    $scope.selectedAll = false;
    $scope.selectAll = function() {
      var selectedAll = !$scope.selectedAll;
      $scope.selectedItems = {};
      for (var i = 0; i < $scope.firmy.length; i++) {
        $scope.firmy[i].selected = selectedAll;
        if (selectedAll) {
          $scope.selectedItems[$scope.firmy[i].id] = $scope.firmy[i];
        } else {
          delete $scope.selectedItems[$scope.firmy[i].id];
        }
      }
      updateOznacenych();
    };


    $scope.selectFirma = function(firma) {
      if ($scope.selectedAll) {
        $scope.selectedAll = false;
      }
      if ($scope.selectedItems[firma.id]) {
        delete $scope.selectedItems[firma.id];
      } else {
        $scope.selectedItems[firma.id] = firma;
      }
      updateOznacenych();
    };

    var updateOznacenych = function() {
      var selectedItemsCount = _.keys($scope.selectedItems).length;
      switch (selectedItemsCount) {
        case 0:
          $scope.selectedItemsText = '';
          break;
        case 1:
          $scope.selectedItemsText = 'Označený '+ selectedItemsCount +' záznam';
          break;
        case 2: case 3: case 4:
          $scope.selectedItemsText = 'Označené '+ selectedItemsCount +' záznamy';
          break;
        default:
          $scope.selectedItemsText = 'Označených '+ selectedItemsCount +' záznamov';
          break;
      }
    };

    var _updateBulk = function (firmy) {
      Firma.updateBulk(firmy)
        .then(
          function () {
            _.each(firmy, function (firma) {
              delete firmy[firma.id];
              _.find($scope.firmy, {id: parseInt(firma.id)}).selected = false;
              Firma.syncChange(firma);
            });

            if ($scope.selectedAll) {
              $scope.selectedAll = false;
            }
            updateOznacenych();
            $scope.SearchCtrl.refresh();
            Notification.add('Zvolené záznamy firiem boli úspešne upravené.', 'success', 10);
          }
        ).catch(
        function (error) {
          if (error.status >= 400 && error.status < 500) {
            Notification.add('Záznamy firiem sa nepodarilo upraviť.', 'danger', 10);
          }
        }
      );
    };

    $scope.setAktivnaStatus = function (status) {
      _.each($scope.selectedItems, function(firma) {
        firma.is_active = status;
      });
      _updateBulk($scope.selectedItems);
    };

  }]);
